import api from '../../../api/client';
import React from 'react'

const CashFlow = () => {
  return (
    <div>CashFlow</div>
  )
}

export default CashFlow